/* eslint-disable max-len */

import React, { useState } from 'react';
import Button from '../Button';

import { useChat } from '../../hooks/useChat';

export function ChatInput({
  location, history, onNextStep,
}) {
  const [message, setMessage] = useState('');
  const {
    addQuestion, generatingAnswer, chatStatus,
  } = useChat();

  const submitQuestion = () => {
    if (message.length === 0) return;
    if (!generatingAnswer) {
      addQuestion(message, () => setMessage(''));
    }
  };

  return (
    <form
      data-testid="chat-input-form"
      onSubmit={(e) => {
        e.preventDefault();
        submitQuestion();
      }}
      className="sticky bottom-0 p-5 bg-white dark:bg-black rounded-t-md border border-black/10 dark:border-white/25 border-b-0 w-full max-w-3xl flex items-center justify-center gap-2 z-20"
    >
      {chatStatus !== 'done' ? (
        <>
          <textarea
        // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            value={message}
            required
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault(); // Prevents the newline from being entered in the textarea
                submitQuestion();
              }
            }}
            className="w-full p-2 border border-gray-300 dark:border-gray-500 outline-none rounded dark:bg-gray-800"
            placeholder="Begin conversation here..."
            data-testid="chat-input"
          />
          <Button
            className="px-3 sm:px-4"
            type="submit"
            isLoading={generatingAnswer}
            data-testid="submit-button"
          >
            {generatingAnswer
              ? 'Thinking...'
              : 'Chat'}
          </Button>
        </>
      ) : ''}
      {chatStatus !== 'normal' ? (
        <Button
          type="button"
          className="btn btn-secondary px-3 sm:px-4"
          onClick={() => onNextStep(history, location.state)}
          data-cy="nextButton"
        >
          Next
        </Button>
      )
        : ''}
    </form>
  );
}

export default ChatInput;
